import { axiosInstance } from "../../utils";

const actions = {
    FETCH_CATEGORIES_REQUESTED: 'FETCH_CATEGORIES_REQUESTED',
    FETCH_CATEGORIES_SUCCEEDED: 'FETCH_CATEGORIES_SUCCEEDED',
    FETCH_CATEGORIES_FAILED: 'FETCH_CATEGORIES_FAILED',

    FETCH_CATEGORY_REQUESTED: 'FETCH_CATEGORY_REQUESTED',
    FETCH_CATEGORY_SUCCEEDED: 'FETCH_CATEGORY_SUCCEEDED',
    FETCH_CATEGORY_FAILED: 'FETCH_CATEGORY_FAILED',

    DELETE_CATEGORY_REQUESTED: 'DELETE_CATEGORY_REQUESTED',
    DELETE_CATEGORY_SUCCEEDED: 'DELETE_CATEGORY_SUCCEEDED',
    DELETE_CATEGORY_FAILED: 'DELETE_CATEGORY_FAILED',

    CLEAR_ALERT_MESSAGE: 'CLEAR_ALERT_MESSAGE',

    clearAlertMessage: (params = undefined) => {
        return {
            type: actions.CLEAR_ALERT_MESSAGE,
            payload: params
        }
    },

    fetchCategories: (params = undefined) => {
        return {
        type: actions.FETCH_CATEGORIES_REQUESTED,
        payload: params
    }},

    fetchCategory: (params = undefined) => {
        return {
            type: actions.FETCH_CATEGORY_REQUESTED,
            payload: params
        }
    },
    
    removeCategory: (id = undefined) => {
        return {
            type: actions.DELETE_CATEGORY_REQUESTED,
            payload: id
        }
    },

    getCategories: async (params = undefined) => {
        const url = `categories`;

        try {
            const categories = await axiosInstance.get(url,{ params });
            return categories.data;
        } catch (error) {
            throw error;
        }
    },

    getCategory: async (category_id = undefined) => {
        const url = `categories/`+category_id;

        try {
            const category = await axiosInstance.get(url);
            return category.data;
        } catch (error) {
            throw error;
        }
    },

    deleteCategory: async (id = undefined) => {
        const url = `categories/` + id;
        
        try {
            const response = await axiosInstance.delete(url);
            return response;
        } catch (error) {
            throw error;
        }
    }
};
export default actions;
